import { Button, Stack } from '@mui/material';
import PersianSupportTextField from 'Global/Components/UnEditableComponents/PersianSupportTextField/PersianSupportTextField';
import i18next from 'i18next';
import React, { useState } from 'react';
import { HandleAddSuggestion } from '../functions/HandleAddSuggestion';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';

const AddSuggestion = ({
  FindLangKey,
  element,
  setForceRender,
}) => {
  const titleLabel = FindLangKey(
    'general-public-label-title'
  );
  const descriptionLabel = FindLangKey(
    'general-public-label-description'
  );
  const addLabel = FindLangKey('general-public-label-add');
  const networkErrorMsg = FindLangKey(
    'general-public-alert-network-error'
  );
  const processingRequestMsg = FindLangKey(
    'general-public-alert-doing-request'
  );
  const [sugegstionData, setSuggestionData] = useState({
    title: '',
    description: '',
  });

  const HandleTitleChange = (title) => {
    setSuggestionData((prev) => ({
      ...prev,
      title,
    }));
  };
  const HandleDescriptionChange = (description) => {
    setSuggestionData((prev) => ({
      ...prev,
      description,
    }));
  };

  return (
    <React.Fragment>
      <Stack
        mb="1em"
        gap="0.3em"
        onClick={(event) => {
          event.stopPropagation();
        }}
      >
        <PersianSupportTextField
          label={titleLabel}
          isSmall={true}
          isEnglish={i18next.language === 'en'}
          onChange={HandleTitleChange}
        />
        <PersianSupportTextField
          label={descriptionLabel}
          isSmall={true}
          isEnglish={i18next.language === 'en'}
          onChange={HandleDescriptionChange}
        />
        <Button
          disabled={
            sugegstionData?.description.trim()?.length ===
              0 ||
            setSuggestionData?.title?.trim()?.length === 0
          }
          variant="contained"
          onClick={() => {
            HandleAddSuggestion(
              sugegstionData,
              element,
              networkErrorMsg,
              setForceRender,
              processingRequestMsg
            );
          }}
          sx={{
            color: `${themeColors.ColorPrimary} !important`,
          }}
        >
          {addLabel}
        </Button>
      </Stack>
      <hr />
    </React.Fragment>
  );
};

export default AddSuggestion;
